import React, { useState, useCallback, useEffect } from 'react';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PeopleIcon from '@mui/icons-material/People';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Menu as MenuIcon } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Buttons/Button';
import ThreeppModal from '../../common/Modal/Modal';

import { ControlledSection } from '../../common/ControlledSection/ControlledSection';

import './Help.scss';

const allEqual = arr => arr.every(v => v === arr[0]);

export const Help = props => {
  const { toggle, isOpen } = props;

  const { t } = useTranslation();

  const [sectionExpanded, setSectionExpanded] = useState([false, false, false, false, false, false, false, false]);
  const [expandAllSections, setExpandAllSections] = useState(false);
  const [expandSectionsLabel, setExpandSectionsLabel] = useState('');

  useEffect(() => {
    if (expandAllSections) {
      setExpandSectionsLabel(t('help.collapseAll'));
    } else {
      setExpandSectionsLabel(t('help.expandAll'));
    }
  }, [expandAllSections, t]);

  const onOpened = useCallback(() => {
    setSectionExpanded([false, false, false, false, false, false, false, false]);
    setExpandAllSections(false);
  }, []);

  const close = useCallback(() => {
    toggle();
  }, [toggle]);

  const toggleAllSections = useCallback(() => {
    if (expandAllSections) {
      setSectionExpanded([false, false, false, false, false, false, false, false]);
      setExpandAllSections(false);
    } else {
      setSectionExpanded([true, true, true, true, true, true, true, true]);
      setExpandAllSections(true);
    }
  }, [expandAllSections]);

  const toggleSection = useCallback(
    index => {
      const temp = [...sectionExpanded];
      temp[index] = !temp[index];

      setSectionExpanded(temp);

      if (allEqual(temp)) {
        setExpandAllSections(temp[index]);
      }
    },
    [sectionExpanded]
  );

  const footer = (
    <>
      <div className="version">{t('help.version')}</div>
      <Button className="btn-cancel" buttonStyle="primary" onClick={close}>
        {t('common.close')}
      </Button>
    </>
  );

  return (
    <>
      <ThreeppModal
        onOpened={onOpened}
        isOpen={isOpen}
        toggle={toggle}
        classes="help-modal"
        header={t('help.header')}
        footer={footer}
        footerClass="justify-footer-content"
        size="lg"
      >
        <div className="help-content">
          <div className="para">{t('help.intro.line1')}</div>
          <div className="para">{t('help.intro.line2')}</div>
          <div className="para">{t('help.intro.line3')}</div>
          <ol>
            <li>{t('help.intro.listItem1')}</li>
            <li>{t('help.intro.listItem2')}</li>
            <li>{t('help.intro.listItem3')}</li>
            <li>{t('help.intro.listItem4')}</li>
          </ol>
        </div>
        {/* TODO: Fix this... */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events  */}
        <div className="expand-all-label" onClick={toggleAllSections}>
          {expandSectionsLabel}
        </div>

        <ControlledSection
          className="help-content"
          name={t('help.section1.question')}
          expanded={sectionExpanded[0]}
          toggleExpanded={() => toggleSection(0)}
        >
          <div className="para">
            {t('help.section1.line1')}
            <InfoOutlinedIcon className="icon-color" />
            <ul>
              <li>{t('help.section1.listItem1')}</li>
              <li>{t('help.section1.listItem2')}</li>
              <li>{t('help.section1.listItem3')}</li>
            </ul>
            <div className="para">
              <span>{t('help.section1.line2')}</span>
              <PeopleIcon className="icon-color" />
              <span>{t('help.section1.line3')}</span>
            </div>
            <div className="para">{t('help.section1.line4')}</div>
          </div>
        </ControlledSection>

        <ControlledSection
          className="help-content"
          name={t('help.section2.question')}
          expanded={sectionExpanded[1]}
          toggleExpanded={() => toggleSection(1)}
        >
          <div>
            <div className="para">
              <span>{t('help.section2.line1')}</span>
              <GroupAddIcon className="icon-color" />
              <span>{t('help.section2.line2')}</span>
            </div>
            <ul>
              <li>{t('help.section2.listItem1')}</li>
              <li>{t('help.section2.listItem2')}</li>
            </ul>
            <div className="para">{t('help.section2.line3')}</div>
            <div className="para">{t('help.section2.line4')}</div>
          </div>
        </ControlledSection>

        <ControlledSection
          className="help-content"
          name={t('help.section3.question')}
          expanded={sectionExpanded[2]}
          toggleExpanded={() => toggleSection(2)}
        >
          <div>
            <div className="para">{t('help.section3.line1')}</div>
            <div className="para">{t('help.section3.line2')}</div>

            <div className="para">
              <span>{t('help.section3.line3')}</span>
              <span>
                <FilterAltIcon icon="filter" className="icon-color" />
              </span>
              <span>{t('help.section3.line4')}</span>
            </div>

            <div className="para">{t('help.section3.line5')}</div>
          </div>
        </ControlledSection>

        <ControlledSection
          className="help-content"
          name={t('help.section7.question')}
          expanded={sectionExpanded[3]}
          toggleExpanded={() => toggleSection(3)}
        >
          <div>
            <div className="para">{t('help.section7.line1')}</div>
            <ul>
              <li>{t('help.section7.listItem1')}</li>
              <li>{t('help.section7.listItem2')}</li>
              <li>{t('help.section7.listItem3')}</li>
              <li>{t('help.section7.listItem4')}</li>
              <li>{t('help.section7.listItem5')}</li>
              <li>{t('help.section7.listItem6')}</li>
              <li>{t('help.section7.listItem7')}</li>
              <li>{t('help.section7.listItem8')}</li>
              <li>{t('help.section7.listItem9')}</li>
              <li>{t('help.section7.listItem10')}</li>
              <li>{t('help.section7.listItem11')}</li>
            </ul>
            <div className="para">{t('help.section7.line2')}</div>
            <ul>
              <li>{t('help.section7.listItem12')}</li>
              <li>{t('help.section7.listItem13')}</li>
              <li>{t('help.section7.listItem14')}</li>
              <li>{t('help.section7.listItem15')}</li>
              <li>{t('help.section7.listItem16')}</li>
            </ul>
          </div>
        </ControlledSection>

        <ControlledSection
          className="help-content"
          name={t('help.section4.question')}
          expanded={sectionExpanded[4]}
          toggleExpanded={() => toggleSection(4)}
        >
          <div className="para">{t('help.section4.line1')}</div>
        </ControlledSection>

        <ControlledSection
          className="help-content"
          name={t('help.section5.question')}
          expanded={sectionExpanded[5]}
          toggleExpanded={() => toggleSection(5)}
        >
          <div>
            <div className="para">{t('help.section5.line1')}</div>
            <ul>
              <li>
                <div>
                  <b>{t('help.section5.listItem1')}</b>
                </div>
                <div>{t('help.section5.listItem1Desc')}</div>
              </li>
              <li>
                <div>
                  <b>{t('help.section5.listItem2')}</b>
                </div>
                <div>{t('help.section5.listItem2Desc')}</div>
              </li>
            </ul>
          </div>
        </ControlledSection>

        <ControlledSection
          className="help-content"
          name={t('help.section6.question')}
          expanded={sectionExpanded[6]}
          toggleExpanded={() => toggleSection(6)}
        >
          <div>
            <div className="para">
              <span>{t('help.section6.line1')}</span>
              <span>
                <MenuIcon />
              </span>
              <span>{t('help.section6.line2')}</span>
            </div>
          </div>
        </ControlledSection>

        <ControlledSection
          className="help-content"
          name={t('help.section8.question')}
          expanded={sectionExpanded[7]}
          toggleExpanded={() => toggleSection(7)}
        >
          <div>
            <div className="para">{t('help.section8.line00')}</div>
            <div className="para">
              <span className="bold">{t('help.section8.line01')}</span>
              {t('help.section8.line02')}
            </div>
            <div className="para">{t('help.section8.line1')}</div>
            <div className="para">{t('help.section8.line2')}</div>
            <div className="para">{t('help.section8.line3')}</div>
            <div className="para">{t('help.section8.line4')}</div>
            <div className="para">{t('help.section8.line5')}</div>
            <div className="para">{t('help.section8.line6')}</div>
          </div>
        </ControlledSection>
      </ThreeppModal>
    </>
  );
};

export default Help;
